import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const eocReportsTeamRoute: InvariantJiraRoute = {
	name: 'eoc-reports-team',
	path: '/jira/ops/teams/:teamId/reports/:dashboardId',
	exact: true,
};
